import React from "react";
import {LinkSharp, WhatsApp} from "@material-ui/icons";
import {Instagram, Phone, PhoneCall, Share2} from "react-feather";
import {Col, NavLink, Row} from "reactstrap";
import logo from "../../../assets/img/logo/logo.webp";
import {FaInstagram} from "react-icons/fa";
import {FaTelegramPlane} from "react-icons/fa";
import Technical from "../../../assets/img/logo/Technical professional.png";
import {FiPhoneCall, FiYoutube} from "react-icons/fi";
import {MdOutlineWhatsapp} from "react-icons/md";
import zarin from "../../../assets/img/elements/zarin.png"
import data from "../../../assets/data/configs/storeConfig.json"
import {connect} from "react-redux";
import RenderMedia from "../../media/renderMedia";
import {Link} from "react-router-dom";


class Footer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            whatsapp: false,
            enamad: true,
            quick_access: this.props.UI.menu ? this.props.UI.menu : [],
            courses: this.props.UI.courses ? this.props.UI.courses : [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((this.props.UI !== prevProps.UI)) {
            this.setState({
                quick_access: this.props.UI.menu ? this.props.UI.menu : [],
                courses: this.props.UI.courses ? this.props.UI.courses : [],

            })
        }
    }

    support = () => {
        this.setState({
            whatsapp: !this.state.whatsapp,
        })
    }

    render() {
        return (
            <>
                <div className="web-footer">
                    <div className='web-footer-top m-auto rounded d-flex align-items-center justify-content-around p-4'>
                        <div>
                            <span className='h2 text-white'>جهت کسب اطلاعات بیشتر با ما در تماس باشید.</span>
                        </div>
                        <div>
                            <a href={`tel:${data.mobile[0]}`}>
                                <button className="btn">
                                    <FiPhoneCall/>
                                    {data.mobile[0]}
                                </button>
                            </a>
                        </div>
                    </div>
                    <div className="bg-black-footer ">
                        <Row>
                            <Col md={4} sm={12}>
                                <div className='footer-logo'>

                                    <h4>{data.faName}</h4>
                                </div>
                                <div className='footer-desc'>
                                    <p>
                                        {data.homeAbout}
                                    </p>
                                </div>
                                <div className='footer-social'>
                                    {
                                        data.socialMedia && <RenderMedia/>
                                    }
                                </div>
                            </Col>
                            <Col md={8} sm={12}>
                                <Row>
                                    <Col md={3} sm={12}>
                                        <h5 className='title-footer'>لینک دسترسی سریع</h5>
                                        <div className='footer-speed-container'>
                                            {
                                                this.state.quick_access?.slice(0, 5)?.map((item) => (
                                                    <div className='footer-link-speeed'>
                                                        <Link to={item.url}>{item.title}</Link>
                                                    </div>
                                                ))
                                            }

                                        </div>
                                    </Col>
                                    <Col md={3} sm={12}>
                                        <h5 className='title-footer'>دوره ها</h5>
                                        <div className='footer-speed-container'>
                                            {
                                                this.state.courses?.slice(0, 5)?.map((item) => (
                                                    <div className='footer-link-speeed'>
                                                        <Link to={`/courses/${item.slug}`}> {item.title} </Link>
                                                    </div>
                                                ))
                                            }

                                        </div>
                                    </Col>
                                    <Col md={3} sm={12}>
                                        <h5 className='title-footer'>تماس با ما</h5>

                                        <div className='footer-location'>
                                            <span>آدرس: </span>
                                            {data.address && <p>{data.address}</p>}
                                        </div>

                                        <div className='footer-phone'>
                                            <span>تلفن: </span>
                                            {data.mobile?.map(item => (
                                                <a href={`tel:${item}`}>
                                                    <Phone/> {item}
                                                </a>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col md={3} sm={12}>
                                        <div>
                                            <iframe
                                                className="map-contact"
                                                src={data.iframeLink}
                                                title={`مشاهده «${data.name}»`}
                                                width="600"
                                                height="450"
                                                style={{width: "100%", height: "auto", border: "0"}}></iframe>
                                            <div className='footer-item-nemad mt-1'>
                                                <div className=" nemad-box">
                                                    <a referrerPolicy='origin' target='_blank'
                                                       className=''
                                                       href={data.enamadLink}><img
                                                        referrerPolicy='origin'
                                                        src={data.enamadLinkImg}
                                                        alt='' style={{cursor: 'pointer'}} Code={data.enamadCode}/></a>
                                                </div>
                                                <div className=' nemad-box '>
                                                    <img src={zarin}/>
                                                </div>
                                            </div>

                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                    </div>

                    <div className='border-footer'></div>

                    <div className="copyright p-1 w-100 m-auto">
                        <p className="m-0">
                            {'کلیه حق و حقوق وبسایت برای '}
                            <a href={data.url}>
                                <strong className='text-bold'>
                                    {data.faName}
                                </strong>
                            </a>
                            {' محفوظ است. '}
                        </p>
                        <a href="https://barantm.ir" target='_blank' rel='noopener' className="my-auto">
                            <p className="m-0">
                                {' این وبسایت توسط '}
                                <a href="https://barantm.com">
                                    <strong className='text-bold'>
                                        شرکت برنامه نویسی باران
                                    </strong>
                                </a>
                                {'  طراحی و تولید شده است.'}
                            </p>
                        </a>

                    </div>

                </div>

                <div className="copyright copyright-phone p-1 w-100 m-auto">
                    <p className="m-0">
                        کلیه حق و حقوق وبسایت برای {data.faName} محفوظ است
                    </p>
                </div>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        UI: state.UI
    }
}

export default connect(mapStateToProps)(Footer);
